const ITEMS = [
  "Emergency Relief",
  "Food Security",
  "Family Empowerment",
  "Clean Water",
  "Youth Education",
  "Housing Stability",
];

const Star = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 1l2.4 8.6L23 12l-8.6 2.4L12 23l-2.4-8.6L1 12l8.6-2.4z" />
  </svg>
);

export const Marquee = () => (
  <div data-testid="marquee-pillars" className="overflow-hidden bg-night py-7">
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {ITEMS.map((item) => (
            <span
              key={`${dup}-${item}`}
              className="mx-8 flex items-center gap-8 whitespace-nowrap font-serif text-2xl italic text-[#FAF7F2]/90"
            >
              {item}
              <span className="text-warm">
                <Star />
              </span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
